import React from 'react'
import styled from 'styled-components'
import { ProgressBar, Cell, Grid } from 'react-mdl'
import Button from '../../components/Button'
import ImageItem from './ImageItem'

const PanelButton = styled(Button)`
  width: 49%;
  height: 120px;
`
const InitialScreen = ({
  imageSuggestions,
  images = [],
  imageIds,
  goToPanel,
  unitImages,
  handleImageSelect,
}) => (
  <div>
    <h3>Insert Image</h3>
    <p>Upload a new image or choose an existing image from the library:</p>
    <div>
      <PanelButton onClick={goToPanel('upload')}>Upload</PanelButton>
      <PanelButton onClick={goToPanel('library')}>Library</PanelButton>
      <PanelButton
        disabled={unitImages.length === 0}
        onClick={goToPanel('unit')}>
        Unit
      </PanelButton>
    </div>
    <div>
      <p>Suggested Images:</p>
      {!imageSuggestions ? (
        <ProgressBar indeterminate />
      ) : imageSuggestions.length === 0 ? (
        <p>No suggestions available.</p>
      ) : (
        <Grid>
          {imageSuggestions.map((image, i) => (
            <Cell key={i} col={3} onClick={handleImageSelect(image)}>
              <ImageItem
                {...image}
                showDescription={false}
                selected={imageIds.includes(image._id)}
              />
            </Cell>
          ))}
          <Cell col={12} style={{ display: 'flex' }}>
            <Button
              style={{ marginLeft: 'auto' }}
              disabled={images.length === 0}
              onClick={goToPanel('edit-images')}>
              Continue
            </Button>
          </Cell>
        </Grid>
      )}
    </div>
  </div>
)

export default InitialScreen



// WEBPACK FOOTER //
// ./src/components/ImageSelectionModal/InitialScreen.js